/**
 * Return an array of dates in the layerData object that match the season year
 * @param {Object} layerData
 * @param {String} seasonYear
 * @return {Array.<String>} Array of dates in the layerData object that match the season year
 */
export function getLayerDatesBySeason(layerData, seasonYear) {
  return Object.keys(layerData).filter(
    (date) => Number(date.split('-')[0]) === seasonYear
  );
}
